import React from 'react';
import PropTypes from 'prop-types';
import { getCookie } from '../../../store/sessionStore';
import { decryptText } from '../../../utils/cookies';
import RestrictedPage from '../../pages/restrictedPage/restrictedPage';

export const hasPermission = (scopes) => {
    const userPermissions = JSON.parse(decryptText(getCookie('userPermissions')));
    let permissions = userPermissions.map(permission => permission.description);
    return permissions.some((permission) => scopes.some((scope) => {
        if(scope){
            return scope.includes(permission) || permission.includes(scope)}
    }));
}

const PermissionGate = (props) => {

    const {
        children,
        scopes,
        restrictPage,
    } = props;

    
    const permissionGranted = hasPermission(scopes);

    let response = <>{children}</>;
    if(!permissionGranted){
        if(restrictPage)
            response = <RestrictedPage/>;
        else
            response = <></>
    }


    return response; 
}

PermissionGate.propTypes = {
    children: PropTypes.node.isRequired,
    scopes: PropTypes.arrayOf(PropTypes.any),
    restrictPage: PropTypes.bool
};
  
PermissionGate.defaultProps = {
    children: '',
    disabled: false,
    restrictPage:false,
};

export default PermissionGate;